import { Base } from '@studiometa/js-toolkit';

/**
 * Mascotte component
 */
export default class Mascotte extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Mascotte',
    refs: ['text', 'image'],
  };

  /**
   * Mounted
   */
  mounted() {
    this.initObserver();
  }

  /**
   * Init IntersectionObserver
   */
  initObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              this.$refs.image.classList.remove('opacity-0', 'scale-0', 'translate-y-16');
            }, 1000);
            setTimeout(() => {
              this.$refs.text.classList.remove('opacity-0', 'scale-50');
            }, 2000);

            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 1,
      },
    );

    observer.observe(this.$el);
  }
}
